var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-icon',{class:{'descending' : _vm.descending},attrs:{"small":""}},[_vm._v("mdi-arrow-up")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }